import React from 'react';
import { motion } from 'framer-motion';
import HeroBackground from './hero/HeroBackground';
import HeroHeading from './hero/HeroHeading';
import HeroCTA from './hero/HeroCTA';
import TrustIndicators from './hero/TrustIndicators';

const Hero = () => {
  const whatsappNumber = '41784417112';
  const phoneNumber = '0784417112';

  const handleWhatsApp = () => {
    window.open(`https://wa.me/${whatsappNumber}?text=Hallo,%20ich%20möchte%20ein%20Fixpreis-Angebot%20für%20Malerarbeiten%20anfragen.`, '_blank');
  };

  const handleCall = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black pt-20">
      <HeroBackground />

      <div className="container mx-auto px-4 py-20 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          <HeroHeading />
          <HeroCTA onWhatsApp={handleWhatsApp} onCall={handleCall} phoneNumber={phoneNumber} />
          <TrustIndicators />
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          duration: 0.8,
          delay: 1.2,
          repeat: Infinity,
          repeatType: "reverse"
        }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
      >
        <div className="w-6 h-10 border-2 border-slate-600 rounded-full flex justify-center">
          <div className="w-1.5 h-3 bg-blue-500 rounded-full mt-2"></div>
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;
